export default __webpack_public_path__ + "static/media/thales.c98b6d9e.png";